const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
const layer = (css) => { const d = document.createElement("div"); Object.assign(d.style, { position: "fixed", pointerEvents: "none", zIndex: 45, ...css }); document.body.appendChild(d); return d; };

export function acuteBurst(evt, color = "#FF3B30") {
  if (reduced()) return;
  const r = evt?.currentTarget?.getBoundingClientRect?.();
  const x = r ? r.left + r.width / 2 : window.innerWidth / 2;
  const y = r ? r.top + r.height / 2 : window.innerHeight;
  const dim = layer({ inset: "0", background: "rgba(0,0,0,0.18)", backdropFilter: "saturate(0.85)" });
  dim.animate([{ opacity: 0 }, { opacity: 1, offset: 0.4 }, { opacity: 0 }], { duration: 900, easing: "ease-in-out" }).onfinish = () => dim.remove();
  const size = Math.max(window.innerWidth, window.innerHeight) * 1.6;
  const glow = layer({ left: `${x}px`, top: `${y}px`, width: `${size}px`, height: `${size}px`, borderRadius: "9999px", transform: "translate(-50%,-50%) scale(0)",
    background: `radial-gradient(circle, ${color}40 0%, ${color}1f 28%, ${color}0a 48%, transparent 65%)`, filter: "blur(8px)" });
  glow.animate([
    { transform: "translate(-50%,-50%) scale(0.05)", opacity: 0 },
    { transform: "translate(-50%,-62%) scale(0.75)", opacity: 1, offset: 0.45 },
    { transform: "translate(-50%,-75%) scale(1)", opacity: 0 },
  ], { duration: 1000, easing: "cubic-bezier(.22,.9,.3,1)" }).onfinish = () => glow.remove();
  navigator.vibrate?.(14);
}
